import api from './index';
// axios
import request from '@/utils/request';

// 注册
export function register(params) {
  return request({
    url: api.register,
    method: 'post',
    data: params
  });
}

// 登录
export function login(params) {
  return request({
    url: api.Login,
    method: 'post',
    data: params,
    hideloading: false
  });
}

// 设置手机/邮箱
export function userName(params) {
  return request({
    url: api.userName,
    method: 'put',
    data: params,
    hideloading: false
  });
}

// 发送验证码
export function verificationCode(params) {
  return request({
    url: api.verificationCode,
    method: 'post',
    data: params,
    hideloading: false
  });
}

// 忘记密码
export function forgotPassword(params) {
  return request({
    url: api.forgotPassword,
    method: 'put',
    data: params,
    hideloading: false
  });
}

// 获取国家列表
export function getCountry(params) {
  return request({
    url: api.getCountry,
    method: 'get',
    params: params,
    hideloading: false
  });
}